import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import TEFeedbackSignal from '../../types/TEFeedbackSignal';

const Helper = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={TEFeedbackSignal.Helper}>
    {children}
  </InlineFeedbackBase>
);

export default Helper;
